import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DocumentsState } from '@app/core/store/reducers/documents';

const getDocumentsFeatureState = createFeatureSelector<DocumentsState>('documents');

export const getDocuments = createSelector(getDocumentsFeatureState, (state: DocumentsState) => state.documents);

export const getDocumentPages = (username: string) =>
  createSelector(getDocumentsFeatureState, (state: DocumentsState) => state.documentPages[username] ?? {});

export const getPageForDocument = (username: string, docId: string) =>
  createSelector(getDocumentPages(username), (pages) => pages[docId] ?? 1);

export const getOpenedTabIds = (username: string) =>
  createSelector(getDocumentsFeatureState, (state: DocumentsState) => state.openedTabIds[username] ?? []);

export const getActiveTabId = (username: string) =>
  createSelector(getDocumentsFeatureState, (state: DocumentsState) => state.activeTabId[username] ?? null);
